import { hi } from "../../../../date-fns/locale/hi.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    hi
  }
};